import React from 'react';
import { useParams } from 'react-router-dom';
import { Breadcrumbs, BreadcrumbsItem, PageHeader, PageHeaderContent } from 'components';
import { URL } from 'routes/routeConstants';
import { PaymentWorkflowTypes } from 'types';

interface IMakePaymentHeaderProps {
  pageHeaderContent?: React.ReactNode;
}

const paymentWorkflows = Object.values(PaymentWorkflowTypes);

const MakePaymentHeader = ({ pageHeaderContent, ...rest }: IMakePaymentHeaderProps) => {
  const routeParams = useParams<{ workflow?: PaymentWorkflowTypes }>();
  const includeWorkflowCrumb = paymentWorkflows.includes(routeParams?.workflow);

  return (
    <PageHeader {...rest}>
      <Breadcrumbs data-cy="payments-breadcrumbs">
        <BreadcrumbsItem data-cy="payments-breadcrumblink" label="Payments" to={URL.PaymentsOverview} />
        <BreadcrumbsItem data-cy="make-payments-breadcrumblink" label="Make Payment" to={URL.MakePayment} />
        {includeWorkflowCrumb && <BreadcrumbsItem data-cy={`make-payments-${routeParams.workflow}-breadcrumblink`} label={routeParams.workflow} />}
      </Breadcrumbs>

      {pageHeaderContent && <PageHeaderContent>{pageHeaderContent}</PageHeaderContent>}
    </PageHeader>
  );
};

export default MakePaymentHeader;
